import { DataResponse } from "services/response";
import { BASE_API_URL } from "utils/constants";
import { downloadFilePost, downloadFilePostNew, get, post } from '../../utils/api';


// ================================BÁO CÁO THĂM HỎI KHÁCH HÀNG GHÉ THĂM SR=================================================================
export type ReportDetailRateVisitCustomerModel = Partial<{
  taskId: string,
  workFlowName: string
  storeName: string
  mucDoHaiLong: string
  vanDeChuaHaiLong: string,
  phanHoiKhac: string,
  phone: string,
  responseTime: string
  stt: number,
  taskCode: string,
}>
export type ReportGeneralRateVisitCustomerModel = {
  stt: number,
  storeName: string,
  ratKem: string,
  kem: string,
  binhThuong: string,
  haiLong: string,
  ratHaiLong: string,
  tongLuotDanhGia: number,
  diemDanhGiaTB: number,
  employee: string,
}
// Báo cáo tỷ lệ đánh giá trên tổng lượt ghé thăm
export type ReportRatioRatingModel = {
  stt: number,
  storeName: string,
  soLuotGheTham: number,
  luotDanhGia: number,
  tiLeDanhGia: number,
  employee: string
}
// Báo cáo tỷ lệ đánh giá trên tổng lượt ghé thăm
export type ReportAverageRatingOverTimeModel = {
  stt: number,
  storeName: string,
  rating: number,
  averageRating: number,
  diemDanhGiaTB: number,
  diemDanhGiaTB2: number,
  employee: string,
}
// Báo cáo tỷ lệ đánh giá không hài lòng ghé thăm
export type ReportUnsatifiedModel = {
  stt: number,
  storeName: string,
  rating: number,
  averageRating: number,
}
export type WarrantyActiveReportModel = {
  stt: number,
  // tên sản phẩm
  productName: string

  profileName: string
  profileCode: string

  // Khách hàng kích hoạt
  customerActived: boolean
  serial: string,
  so: string
  // ngày AC xuất kho
  fromDate: string
  // Ngày khách hàng kích hoạt
  customerActivedDate: string
  // NPP kích hoạt
  distributorActived: boolean
  // ngày NPP kích hoạt
  distributorActivedDate: string
  // AC kích hoạt
  acActived: boolean
  // ngày AC kích hoạt
  acActivedDate: string
  // ngày bàn giao căn hộ
  expectedDate: string
  // mã căn
  baseCode: string
}
export type CustomerSurveyReportModel = {
  stt: number,
  warrantyName: string,

  goodSP: any,
  normalSP: any,
  notGoodSP: any,

  goodExpertise: any,
  normalExpertise: any,
  notGoodExpertise: any,

  goodBehavior: any,
  normalBehavior: any,
  notGoodBehavior: any,


  notSurvey: any,
  note: any

  customerNoFeedback: any,
  customerUnreachable: any
}
// báo cáo trạng thái công việc nhân viên kỹ thuật
export type WorkStatusReportModel = {

}

// ============================================ Khai báo phương thức ====================================================
export interface IReportVisitCustomerSRServices {
  //    lấy data bóa cáo chi tiết đánh giá khách hàng ghé thăm SR
  getDataReportCTKHSR(data: object): Promise<DataResponse<Array<ReportDetailRateVisitCustomerModel>>>
  // export report
  exportReport(data: object): Promise<void>
  // --------------------------------------------------------------------------------------------
  //    lấy data báo cáo tổng hợp đánh giá khách hàng ghé thăm SR
  getDataReportTHDGKH(data: object): Promise<DataResponse<Array<ReportGeneralRateVisitCustomerModel>>>

  // --------------------------------------------------------------------------------------------
  //    lấy data Báo cáo tỷ lệ đánh giá trên tổng lượt ghé thăm
  getDataReportTLDGTTLGT(data: object): Promise<DataResponse<Array<ReportRatioRatingModel>>>
  // --------------------------------------------------------------------------------------------
  // Lấy data Báo cáo điểm trung bình đánh giá theo thời gian
  getDataReportDDGTBTTG(data: object): Promise<DataResponse<Array<ReportAverageRatingOverTimeModel>>>

  // Lấy data báo cáo tỷ lệ đánh giá không hài lòng
  getDataReportUnsatified(data: object): Promise<DataResponse<Array<ReportUnsatifiedModel>>>


  // lấy công ty theo chi nhánh
  getCompanyBySaleOrg(saleOrg: string): Promise<DataResponse<''>>


  // Reports/report-tonghopbaohanh Báo cáo tổng hợp kích hoạt bảo hành
  getDataReportWarrantyActive(data: object): Promise<DataResponse<WarrantyActiveReportModel[]>>
  // Báo cáo khảo sát ý kiến khách hàng
  getDataCustomerSurveyReport(data: object): Promise<DataResponse<CustomerSurveyReportModel[]>>
  // Báo cáo trạng thái công việc nhân viên kỹ thuật
  getWorkStatusReport(data: object): Promise<DataResponse<WorkStatusReportModel[]>>

  // ============================================= EXCEL ===============================================================
  exportExcelBC1(data: object): Promise<void>
  exportExcelBC2(data: object): Promise<void>
  exportExcelBC3(data: object): Promise<void>
  exportExcelBC4(data: object): Promise<void>
  exportExcelBC5(data: object): Promise<void>

  // xuất excel báo cáo khảo sát ý kiến khách hàng
  exportExcelCustomerSurvey(data: object): Promise<void>
  exportExcelWorkStatus(data: object): Promise<void>



}
// Hàm khởi tạo các phương thức của Báo cáo bảo hành và khiếu nại service
export function createReportVisitCustomerSRServices(): IReportVisitCustomerSRServices {
  return {
    getDataReportCTKHSR: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-bcctkhsr`, data))
        .data;
    },
    exportReport: async (data) => {
      return (
        await downloadFilePost(
          `Reports/export-excel-ctcdevent`, data))
    },

    // ------------------------------------------------------------------------------------------------
    getDataReportTHDGKH: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-bcthdgkhsr`, data))
        .data;
    },
    // ------------------------------------------------------------------------------------------------
    getDataReportTLDGTTLGT: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-bctldgtlgtsr`, data))
        .data;
    },
    // ------------------------------------------------------------------------------------------------
    // Lấy data Báo cáo điểm trung bình đánh giá theo thời gian
    getDataReportDDGTBTTG: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-bcddgtbttgkhsr`, data))
        .data;
    },
    // Lấy data báo cáo tỷ lệ đánh giá không hài lòng
    getDataReportUnsatified: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-bctidgkhlkhgtsr`, data))
        .data;
    },
    getCompanyBySaleOrg: async (saleOrg) => {
      return (
        await get(
          BASE_API_URL,
          `Common/get-company-by-saleorg`, {
          saleorg: saleOrg
        }))
        .data;
    },

    // Reports/report-tonghopbaohanh Báo cáo tổng hợp kích hoạt bảo hành
    getDataReportWarrantyActive: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-tonghopbaohanh`, data))
        .data;
    },
    // Báo cáo khảo sát ý kiến khách hàng
    getDataCustomerSurveyReport: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-khaosatykienkhachhang`, data))
        .data;
    },
    // Báo cáo khảo sát ý kiến khách hàng
    getWorkStatusReport: async (data) => {
      return (
        await post(
          BASE_API_URL,
          `Reports/report-trangthaicongviecnvkt`, data))
        .data;
    },

    exportExcelBC1: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-bcctkhsr/`, data))
    },
    exportExcelBC2: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-bcthdgkhsr/`, data))
    },
    exportExcelBC3: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-bctldgtlgtsr/`, data))
    },
    exportExcelBC4: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-bcddgtbttgkhsr/`, data))
    },
    exportExcelBC5: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-bctidgkhlkhgtsr/`, data))
    },
    exportExcelCustomerSurvey: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-khaosatykienkhachhang`, data))
    },
    exportExcelWorkStatus: async (data) => {
      return (await downloadFilePostNew(BASE_API_URL, `Reports/export-excel-report-trangthaicongviecnvkt`, data))
    }

  };
}
